import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TimeServiceProvider } from '../../../../../shared/services/helpers/time-service/time.service';
import { AuthTokensService } from '../../../auth-tokens.service';
import { InvoicesDataProvider } from '../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { MessageService } from '../../../../../shared/services/helpers/message-service/message.service';
import { InvoiceServiceProvider } from '../../../../../shared/services/invoice/invoice-service/invoice.service';
import { Subject } from 'rxjs/Subject';
import {
	InvoiceViewBlock,
	SPInvoicesOverviewRequest,
	SPOrdersToImport
} from '../invoice.model';

@Component({
	selector: 'shootproof-invoices-block',
	template: require('./shootproof-invoices-block.component.html'),
	styles: [require('./shootproof-invoices-block.component.scss')]
})
export class ShootproofInvoicesBlockComponent implements OnInit, OnDestroy {
	@Input('shootProofInvoiceLayout') shootProofInvoiceLayout;
	@Input('jobId') jobId: number;
	showLoadingBlock = true;
	showShootProofInvoices = true;

	integrationSystemName: string = null;

	shootProofInvoices: Array<InvoiceViewBlock> = [];
	ordersToImport: Array<SPOrdersToImport> = [];
	ordersToImportUrl: string;
	messagesFromShootProof: string = null;
	getShootProofInvoicesLink: string;
	availableActions: Array<string> = [];

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private http: HttpClient,
		private timeService: TimeServiceProvider,
		private authTokensService: AuthTokensService,
		private invoiceDataService: InvoicesDataProvider,
		private invoiceService: InvoiceServiceProvider,
		private messageService: MessageService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.invoiceDataService.destroyInvoiceUpdatedObservable();
	}

	ngOnInit(): void {
		this.getInvoices();
		this.shouldUpdateInvoiceObservalble();
	}

	private shouldUpdateInvoiceObservalble(): void {
		this.invoiceDataService.shouldInvoiceBeUpdatedObservable
			.takeUntil(this.unsubscribe)
			.filter(value => !!value && value === 'UPDATE_SP_INVOICES')
			.subscribe(() => this.getInvoices());
	}

	private getInvoices(): void {
		this.getShootProofInvoicesLink = this.shootProofInvoiceLayout.fetchEndpoint;

		const headers = this.getHeadersForRequest();

		this.showLoadingBlock = true;

		this.http
			.get(this.getShootProofInvoicesLink, { headers })
			.takeUntil(this.unsubscribe)
			.finally(() => (this.showLoadingBlock = false))
			.subscribe(
				(data: SPInvoicesOverviewRequest) => this.successGetInvoices(data),
				() => this.resetShootProofInvoices()
			);
	}

	successGetInvoices(data: SPInvoicesOverviewRequest): void {
		const { ordersImportingDetails, invoices } = data.data;

		const {
			importNewOrders,
			availableActions,
			showMessage
		} = ordersImportingDetails;

		this.shootProofInvoices = this.invoiceService.setFormattedDaysToDue(
			JSON.parse(JSON.stringify(invoices))
		);

		if (importNewOrders && importNewOrders !== null) {
			this.ordersToImport = importNewOrders.ordersToImport;
			this.ordersToImportUrl = importNewOrders.url;
		}

		this.availableActions = availableActions;
		this.messagesFromShootProof = showMessage;
	}

	importShootProofOrders(): void {
		if (this.availableActions.includes('copyToXero')) {
			this.integrationSystemName = 'Xero';
			this.openCopyInvoiceToQBModal();
		} else if (this.availableActions.includes('copyToQb')) {
			this.integrationSystemName = 'QuickBooks';
			this.openCopyInvoiceToQBModal();
		} else {
			this.importShootProofOrdersWithotSync();
		}
	}

	importShootProofOrdersWithotSync() {
		const link = this.ordersToImportUrl;

		this.showLoadingBlock = true;

		const headers = this.getHeadersForRequest();

		this.http
			.post(link, null, { headers })
			.takeUntil(this.unsubscribe)
			.finally(() => (this.showLoadingBlock = false))
			.subscribe(
				(data: SPInvoicesOverviewRequest) => {
					this.messageService.showToaster('s_7', 'shootProof');
					this.successGetInvoices(data);
				},
				() => this.resetShootProofInvoices()
			);
	}

	private resetShootProofInvoices(): void {
		this.shootProofInvoices = [];
		this.ordersToImport = [];
		this.ordersToImportUrl = null;
		this.messagesFromShootProof = null;
		this.showShootProofInvoices = false;
	}

	private getHeadersForRequest(): HttpHeaders {
		const token = this.authTokensService.getAuthToken();
		return new HttpHeaders().set('Authorization', `Bearer ${token}`);
	}

	openCopyInvoiceToQBModal(): void {
		$('#copyInvoiceToQBConfirmationModal').modal('show');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/invoices/shootproof-invoices-block/shootproof-invoices-block.component.ts